// extracted by mini-css-extract-plugin
export default {"table":"KU1psYMD4PgZbZMOhkBG"};